import { useMemo, useState } from "react";
import { fanWorks, fanWorkTags } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FanWorks() {
  const [activeTag, setActiveTag] = useState("全部");

  const list = useMemo(() => {
    if (activeTag === "全部") return fanWorks;
    return fanWorks.filter((work) => work.tags.includes(activeTag));
  }, [activeTag]);

  return (
    <section id="fanworks" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Fan Works"
          title="同人创作：按题材标签筛选"
          desc="同人区收录主线之外的读者创作，风格差异较大。用下方标签筛选，就能快速缩小到你偏好的那一类，筛选只作用于本页已列出的作品。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {fanWorkTags.map((tag) => {
            const isActive = tag === activeTag;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActiveTag(tag)}
                aria-pressed={isActive}
                className={`px-3.5 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer border transition-colors ${
                  isActive
                    ? "bg-accent-500 text-background-50 border-accent-500"
                    : "bg-background-50 text-foreground-700 border-background-200 hover:border-accent-400 hover:text-accent-800"
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex items-center justify-between text-xs text-foreground-500">
          <span>
            当前筛选：<strong className="font-medium text-foreground-800">{activeTag}</strong>
          </span>
          <span>共 {list.length} 篇</span>
        </div>

        {list.length > 0 ? (
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-5">
            {list.map((work) => (
              <article
                key={work.title}
                className="p-5 rounded-lg bg-background-50 border border-background-200 flex flex-col"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <span className="inline-flex px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 text-xs whitespace-nowrap">
                      {work.type}
                    </span>
                    <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{work.title}</h3>
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-heart-3-line text-primary-500" />
                    {work.likes}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{work.excerpt}</p>
                <div className="mt-4 pt-3 border-t border-background-200 flex flex-wrap items-center justify-between gap-2">
                  <span className="text-xs text-foreground-500">
                    作者 <span className="text-foreground-800 font-medium">{work.author}</span> · {work.length}
                  </span>
                  <div className="flex flex-wrap gap-1.5">
                    {work.tags.map((tag) => (
                      <span key={tag} className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-6 p-8 rounded-lg bg-background-50 border border-dashed border-background-300 text-center">
            <i className="ri-inbox-line text-2xl text-foreground-400" />
            <p className="mt-2 text-sm text-foreground-500">这个标签下暂时没有收录作品，换个标签试试。</p>
          </div>
        )}
      </div>
    </section>
  );
}